// Desktop (md+) persistent left navigation. On phones the same entries live in the
// hamburger drawer (app-menu.tsx) and the bottom tab bar (app-shell.tsx).

import { Link, NavLink } from "react-router-dom";
import { LayoutDashboard, LogOut, SquarePlus } from "lucide-react";

import { useAuth } from "@/lib/auth";
import { APP_NAME, HUB_SECTIONS } from "@/lib/nav";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export function AppSidebar() {
  const { signOut } = useAuth();

  function handleSignOut() {
    // signOut() also ends the org-wide ICM session and navigates away.
    signOut();
  }

  const entries = [
    { href: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
    ...HUB_SECTIONS.map((s) => ({ href: s.href, label: s.label, icon: s.icon, end: false })),
  ];

  return (
    <aside className="hidden w-60 shrink-0 flex-col border-r border-border bg-card md:flex">
      <Link to="/" className="flex h-14 items-center border-b border-border px-5 text-base font-semibold">
        {APP_NAME}
      </Link>

      <div className="p-3">
        <Button nativeButton={false} className="w-full" render={<Link to="/donations/new" />}>
          <SquarePlus /> New donation
        </Button>
      </div>

      <nav className="min-h-0 flex-1 space-y-1 overflow-y-auto px-3" aria-label="Primary">
        {entries.map((i) => (
          <NavLink
            key={i.href}
            to={i.href}
            end={i.end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors",
                isActive ? "bg-accent font-medium text-accent-foreground" : "hover:bg-accent"
              )
            }
          >
            <i.icon className="size-4 text-muted-foreground" />
            {i.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-3">
        <Separator className="mb-3" />
        <Button
          variant="ghost"
          onClick={handleSignOut}
          className="w-full justify-start gap-3 px-3 text-sm font-normal text-destructive hover:bg-destructive/10 hover:text-destructive"
        >
          <LogOut className="size-4" /> Sign out
        </Button>
      </div>
    </aside>
  );
}
